<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="23.000000pt" height="23.000000pt" viewBox="0 0 23.000000 23.000000"
 preserveAspectRatio="xMidYMid meet" id="icon-phone">
    <g transform="translate(0.000000,23.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
<path d="M34 222 c-6 -4 -16 -17 -23 -29 -36 -68 111 -214 183 -182 36 17 39
36 10 55 -21 15 -28 15 -50 4 -23 -13 -27 -11 -61 23 -34 34 -36 38 -23 61 11
22 11 29 -4 51 -19 28 -17 27 -32 17z"/>
</g>
</svg>